import type { IBaseViewModel, IMeasurementViewModel } from '@/engine/app/interfaces';
import {
  createCustomAreaMeasurementAlgorithmBuilder,
  createSplineAlgorithmBuilder
} from '@/engine/PlanningAlgorithm/CustomMeasurementsAlgorithmBuilders';
import type { IIndicationAdder, IIndicationVMAdder } from '../interfaces';
import * as DT from '@/engine/PlanningAlgorithm/DataTypes';
import type { PlanningAlgorithm } from '@/engine/PlanningAlgorithm/PlanningAlgorithm';

export class AreaIndicationAdder implements IIndicationAdder<DT.Polyline> {
  private readonly _planningAlgorithm: PlanningAlgorithm;

  private readonly _indicationsVMAdder: IIndicationVMAdder;

  public constructor(planningAlgorithm: PlanningAlgorithm, indicationVMAdder: IIndicationVMAdder) {
    this._planningAlgorithm = planningAlgorithm;
    this._indicationsVMAdder = indicationVMAdder;
  }

  public async addIndication(
    splineModel: DT.Polyline,
    viewModel: IBaseViewModel,
    attachedViewModel?: IBaseViewModel
  ): Promise<void> {
    if (!attachedViewModel) {
      throw new Error('Attached viewModel is undefined');
    }
    const splineViewModel = attachedViewModel;
    const areaViewModel = viewModel as IMeasurementViewModel;

    await this._planningAlgorithm.extendAlgorithmAsync(
      createSplineAlgorithmBuilder(splineViewModel.descriptor),
      splineViewModel.descriptor
    );

    await this._planningAlgorithm.setValueAsync(
      splineViewModel.descriptor,
      new DT.Polyline({
        points: splineModel.value.points,
        isClosed: true
      })
    );
    this._indicationsVMAdder.addObjectViewModelToViews(splineViewModel);

    await this._planningAlgorithm.extendAlgorithmAsync(
      createCustomAreaMeasurementAlgorithmBuilder(splineViewModel.descriptor, areaViewModel.descriptor),
      areaViewModel.descriptor
    );
    this._indicationsVMAdder.addMeasurementViewModelToViews(areaViewModel);
  }
}
